import type { ListBuilderConfiguration } from '../../types';
import { atRiskItemsList } from './lists/at-risk-items';
import { dueForReorderList } from './lists/due-for-reorder';
import { previouslyPurchasedList } from './lists/previously-purchased';
import { recommendedList } from './lists/recommended';

/**
 * Client Item History list configuration
 * Multi-view (4 tabs): Previously Purchased, Due for Reorder, At Risk, Recommended
 */
export const CLIENT_ITEM_HISTORY_CONFIG: ListBuilderConfiguration = {
	lists: [
		previouslyPurchasedList,
		dueForReorderList,
		atRiskItemsList,
		recommendedList,
	],
	paging: {
		defaultPageSize: 25,
		pageSizeOptions: [25, 50, 100],
	},
	filters: {
		activeFilters: [],
		defaultFilters: {},
	},
	objects: [
		{
			baseUrl: '/invoices/:id',
			objectLabel: 'Invoice',
			objectTable: 'invoice',
			selectedFields: [{ fieldName: 'lastInvoiceId', fieldLabel: 'ID' }],
		},
		{
			baseUrl: '/items/:id',
			objectLabel: 'Item',
			objectTable: 'item',
			selectedFields: [
				{ fieldName: 'itemId', fieldLabel: 'ID' },
				{ fieldName: 'name', fieldLabel: 'Name' },
				{ fieldName: 'sku', fieldLabel: 'SKU' },
				{ fieldName: 'category', fieldLabel: 'Category' },
				{ fieldName: 'subcategory', fieldLabel: 'Subcategory' },
				{ fieldName: 'manufacturer', fieldLabel: 'Manufacturer' },
				{ fieldName: 'price', fieldLabel: 'Unit Price' },
				{ fieldName: 'quantityOnHand', fieldLabel: 'Quantity On Hand' },
				{ fieldName: 'isActive', fieldLabel: 'Active' },
				{ fieldName: 'unitOfMeasure', fieldLabel: 'Unit of Measure' },
				{ fieldName: 'weight', fieldLabel: 'Weight' },
				{ fieldName: 'isHazmat', fieldLabel: 'Hazmat' },
				{ fieldName: 'isRefrigerated', fieldLabel: 'Refrigerated' },
			],
		},
	],
};
